/* Heon site chrome (2026-09): gold flowing lines, fixed masthead with mega menu and search, menu drawer,
   rotating announcement below 1180px.
   Loaded with defer on every page by snippets/heon-head.liquid. The cart count is kept current by the
   theme's own cart scripts, which refill #cart-icon-bubble; the cart drawer binds itself to #cart-icon. */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const T = (k, d) => { const s = window.HeonI18n && window.HeonI18n[k]; return typeof s === 'string' && s ? s : d; };   // the page's language (snippets/heon-i18n-js), else the English default
  const REDUCE = matchMedia('(prefers-reduced-motion:reduce)').matches;

  // gold flowing lines: bundles of fine strands that drift apart and gather again,
  // taken from the swirl in our logo and the embossed lines on our box
  function rng(a){return()=>{a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
  function spline(P){const q=v=>v.toFixed(1),n=P.length;let d='M'+q(P[0][0])+' '+q(P[0][1]);
    for(let i=0;i<n-1;i++){const a=P[Math.max(i-1,0)],b=P[i],c=P[i+1],e=P[Math.min(i+2,n-1)];
      d+='C'+q(b[0]+(c[0]-a[0])/6)+' '+q(b[1]+(c[1]-a[1])/6)+' '+q(c[0]-(e[0]-b[0])/6)+' '+q(c[1]-(e[1]-b[1])/6)+' '+q(c[0])+' '+q(c[1]);}
    return d;}
  // g: {pts:[[x,y]...] in px, spread:[px per point], n strands, jit px, seed, op, clip:[x,y,w,h]}
  function strands(g){const R=rng(g.seed),P=g.pts,out=[];
    const nm=P.map((p,i)=>{const a=P[Math.max(i-1,0)],b=P[Math.min(i+1,P.length-1)],dx=b[0]-a[0],dy=b[1]-a[1],l=Math.hypot(dx,dy)||1;return[-dy/l,dx/l];});
    for(let s=0;s<g.n;s++){const t=g.n>1?s/(g.n-1)-.5:0;out.push(spline(P.map((p,i)=>{const o=g.spread[i]*t+(R()-.5)*g.jit;return[p[0]+nm[i][0]*o,p[1]+nm[i][1]*o];})));}
    return out;}
  function paint(svg,groups,animate){const w=svg.clientWidth,h=svg.clientHeight;if(!w||!h)return;
    svg.setAttribute('viewBox','0 0 '+w+' '+h);let out='';
    groups(w,h).forEach((g,gi)=>{const id=svg.id+gi;let open='<g stroke-opacity="'+(g.op||1)+'"';
      if(g.clip){out+='<clipPath id="'+id+'"><rect x="'+g.clip[0]+'" y="'+g.clip[1]+'" width="'+g.clip[2]+'" height="'+g.clip[3]+'"/></clipPath>';open+=' clip-path="url(#'+id+')"';}
      out+=open+'>';strands(g).forEach(d=>out+='<path d="'+d+'"/>');out+='</g>';});
    svg.innerHTML=out;
    if(animate&&!REDUCE)svg.querySelectorAll('path').forEach((p,j)=>{const L=Math.ceil(p.getTotalLength())+2;
      p.style.strokeDasharray=L;p.style.strokeDashoffset=L;p.style.animation='hh-draw 3.6s cubic-bezier(.4,.5,.2,1) '+(j*.12)+'s forwards';});}
  // points given as fractions of the box, converted to px
  const F=(w,h,a)=>a.map(([x,y])=>[x*w,y*h]);
  const hero=$('.hh-hero-media');
  // homepage: one swirl runs from the header down through the hero copy
  const homeTop=(w,h)=>{
    // phones: the header stays clean; three light strands run down the right side of the hero copy,
    // which sits on the lower part of the film
    if(w<=760){const svg=$('#hh-flowTop'),cp=$('.hh-hero-copy'),top=cp.getBoundingClientRect().top-svg.getBoundingClientRect().top-30,ch=h-top;return[
      {pts:[[w+12,top],[.8*w,top+.28*ch],[.92*w,top+.55*ch],[.74*w,top+.82*ch],[.58*w,h+12]],spread:[8,30,16,36,12],n:3,jit:2,seed:7,op:.5,clip:[0,top-40,w,ch+40]}];}
    return[
      {pts:F(w,h,[[-.03,.13],[.08,.10],[.19,.035],[.26,.13],[.31,.24],[.25,.34],[.155,.285],[.185,.19],[.285,.215],[.395,.40],[.425,.62],[.335,.83],[.17,.935],[-.03,.985]]),spread:[8,26,42,20,56,22,66,28,42,16,78,34,56,14],n:5,jit:4,seed:11},
      {pts:F(w,h,[[-.03,.52],[.045,.64],[.03,.80],[.12,.91],[.30,1.02]]),spread:[4,22,10,30,8],n:3,jit:3,seed:5,op:.6}];};
  // every other page: a shorter swirl inside the header only
  const headTop=(w,h)=>{
    if(w<=760)return[];  // phones: no lines in the header
    return[
      {pts:F(w,h,[[-.02,.94],[.05,.80],[.10,.50],[.14,.22],[.185,.12],[.215,.32],[.22,.60],[.25,.70],[.285,.44],[.30,.08],[.31,-.14]]),spread:[4,10,16,10,8,14,10,12,16,8,6],n:4,jit:2.5,seed:11},
      {pts:F(w,h,[[-.02,.30],[.05,.16],[.11,.30],[.17,.04],[.2,-.14]]),spread:[3,8,12,6,4],n:3,jit:2,seed:5,op:.55}];};
  const FLOWS=[
    [$('#hh-flowTop'),homeTop],
    [$('#hh-flowHead'),headTop],
    [$('#hh-flowEd'),(w,h)=>[{pts:F(w,h,[[-.03,.14],[.15,.07],[.36,.2],[.30,.5],[.12,.62],[.2,.86],[.45,1.03]]),spread:[6,30,14,44,18,36,10],n:5,jit:4,seed:21}]],
    // newsletter band; on phones the text and form fill the width, so the lines stay in the top corner
    [$('#hh-flowJoin'),(w,h)=>w<=760?[{pts:[[.5*w,-14],[.66*w,22],[.85*w,40],[w+14,24]],spread:[4,16,24,10],n:4,jit:3,seed:31,clip:[0,0,w,58]}]
      :[{pts:F(w,h,[[1.03,.06],[.80,.22],[.92,.58],[.70,.86],[.55,1.06]]),spread:[6,30,12,36,10],n:4,jit:3,seed:31}]]
  ].filter(([el])=>el);
  // only the homepage draws its lines in; other pages show them still
  let lastW=0;const sized=[],box=el=>el.clientWidth+'x'+el.clientHeight;
  function paintAll(animate){lastW=innerWidth;FLOWS.forEach(([el,g],i)=>{paint(el,g,animate&&i===0&&!!hero);sized[i]=box(el);});}
  requestAnimationFrame(()=>paintAll(true));
  // fonts or images can change a box after first paint: redraw only what moved
  addEventListener('load',()=>FLOWS.forEach(([el,g],i)=>{if(box(el)!==sized[i]){paint(el,g,i===0&&!!hero&&performance.now()<5000);sized[i]=box(el);}}));
  let rt;addEventListener('resize',()=>{if(innerWidth===lastW)return;clearTimeout(rt);rt=setTimeout(()=>paintAll(false),150);});

  // ---------- masthead: fixed; clear over the homepage film at the very top, ivory glass once the page moves ----------
  const mast = $('#hh-mast');
  if (mast) {
    const dr = $('#hh-drawer'), mb = $('#hh-menuBtn'), sq = $('#hh-search');
    const root = document.documentElement, over = mast.classList.contains('hh-mast--over');
    const bar = $('.hh-bar'), logo = $('.hh-logo'), navIn = $('.hh-nav-in'), ink = $('.hh-nav-ink');
    const navLinks = $$('.hh-nav a[data-mega]'), mega = $('#hh-mega'), scrim = $('#hh-scrim');
    const panels = {}; $$('#hh-mega [data-mp]').forEach(p => { panels[p.dataset.mp] = p; });
    const ORDER = ['new', 'jewelry', 'chains', 'symbols', 'gifts', 'story'];
    const wide = () => innerWidth > 760;
    const v = n => parseFloat(getComputedStyle(mast).getPropertyValue(n)) || 0;
    let scrolled = false, cur = null, openY = 0, tOpen, tClose;

    // wide screens fold the menu into the bar when condensed, if it fits between the logo and the tools
    function measure() {
      if (!wide()) { mast.classList.remove('can-morph'); setHeight(); return; }
      const s = v('--hh-logo-s'), w0 = logo.offsetWidth, pad = parseFloat(getComputedStyle(bar).paddingLeft);
      const x = pad - logo.offsetLeft - w0 * (1 - s) / 2;
      mast.style.setProperty('--hh-logo-x', x.toFixed(1) + 'px');
      const a = navLinks[0].getBoundingClientRect(), b = navLinks[navLinks.length - 1].getBoundingClientRect();
      const br = bar.getBoundingClientRect(), tools = 3 * 44 - 11;
      // transforms move the menu only vertically, so this holds whether or not the bar is folded right now
      mast.classList.toggle('can-morph', a.left >= br.left + pad + w0 * s + 36 && b.right <= br.right - pad - tools - 36);
      setHeight();
    }
    // the theme's sticky columns (product page) sit under the condensed header
    function setHeight() {
      const h = wide() && !mast.classList.contains('can-morph') ? v('--hh-bar-c') + v('--hh-navh') : v('--hh-bar-c');
      root.style.setProperty('--header-height', h + 'px');
    }
    function onScroll() {
      const s = scrollY > 8;
      if (s !== scrolled) { scrolled = s; mast.classList.toggle('is-scrolled', s); if (cur) place(); }
      mast.classList.toggle('is-clear', over && !s && !cur);
      if (cur && Math.abs(scrollY - openY) > 80 && !mast.matches(':hover')) close();
    }
    addEventListener('scroll', onScroll, { passive: true });
    measure(); onScroll();
    document.fonts && document.fonts.ready.then(measure);
    let mt; addEventListener('resize', () => { clearTimeout(mt); mt = setTimeout(() => { measure(); if (cur && !wide()) close(true); else if (cur) place(); }, 120); });

    // panel pictures load the first time a panel is seen; product rows ("new in", bestsellers) come live from the
    // heon-mega-new section through the Section Rendering API, one request per list
    const loaded = new Set();
    function wakePanel(el) {
      el.querySelectorAll('img[data-src]').forEach(i => { i.src = i.dataset.src; i.removeAttribute('data-src'); });
      el.querySelectorAll('.hh-mp-prods[data-load]').forEach(b => loadBoxes(b.dataset.load));
    }
    function loadBoxes(url) {
      if (!url || loaded.has(url)) return; loaded.add(url);
      const boxes = $$('.hh-mp-prods[data-load]').filter(b => b.dataset.load === url);
      fetch(url).then(r => r.ok ? r.text() : Promise.reject(r.status)).then(html => {
        const d = new DOMParser().parseFromString(html, 'text/html'), items = [...d.querySelectorAll('.hh-mp-prod')];
        if (!items.length) return;
        boxes.forEach(b => { b.innerHTML = items.map(i => i.outerHTML).join(''); b.classList.add('is-in'); b.removeAttribute('data-load'); });
        place();
      }).catch(() => boxes.forEach(b => b.remove()));
    }

    // ink line under the menu: follows the open item; rests under the current page's item
    function inkTo(a, anim = true) {
      if (!ink) return;
      if (!a) { navIn.classList.remove('has-ink'); return; }
      navIn.classList.toggle('no-anim', !anim || !navIn.classList.contains('has-ink'));
      ink.style.width = a.offsetWidth + 'px'; ink.style.transform = `translateX(${a.offsetLeft}px)`;
      navIn.classList.add('has-ink');
    }
    const current = $('.hh-nav a[aria-current]');
    const inkRest = () => inkTo(wide() ? current : null, false);
    inkRest();

    // mega menu: one panel at a time; the next slides in from the side you moved toward
    function place() { if (cur && panels[cur]) mega.style.height = panels[cur].offsetHeight + 'px'; }
    const ro = 'ResizeObserver' in window ? new ResizeObserver(() => place()) : null;
    Object.values(panels).forEach(p => ro && ro.observe(p));
    function open(key, focus) {
      clearTimeout(tClose); clearTimeout(tOpen);
      if (!wide() || !panels[key]) return;
      if (key === cur) return;
      const prev = cur, dir = prev ? Math.sign(ORDER.indexOf(key) - ORDER.indexOf(prev)) : 0, next = panels[key];
      if (prev) {
        const p = panels[prev]; p.style.setProperty('--from', (-dir * 48) + 'px'); p.classList.remove('is-on'); p.inert = true;
        $$(`.hh-mast [data-mega="${prev}"]`).forEach(x => x.setAttribute('aria-expanded', 'false'));
      } else openY = scrollY;
      cur = key; wakePanel(next);
      next.style.setProperty('--from', (dir * 48) + 'px'); next.inert = false;
      void next.offsetWidth; next.classList.add('is-on');
      $$(`.hh-mast [data-mega="${key}"]`).forEach(x => x.setAttribute('aria-expanded', 'true'));
      mast.classList.add('mega-open'); mast.classList.remove('is-clear'); scrim && scrim.classList.add('is-on');
      place();
      inkTo(navLinks.find(a => a.dataset.mega === key) || current, !!prev);
      if (focus) { const f = next.querySelector('a[href], input'); f && f.focus({ preventScroll: true }); }
    }
    function close(now) {
      clearTimeout(tOpen); clearTimeout(tClose);
      if (!cur) return;
      const p = panels[cur]; p.style.setProperty('--from', '0px'); p.classList.remove('is-on'); p.inert = true;
      $$(`.hh-mast [data-mega="${cur}"]`).forEach(x => x.setAttribute('aria-expanded', 'false'));
      cur = null; mega.style.height = '0px';
      mast.classList.remove('mega-open'); scrim && scrim.classList.remove('is-on');
      inkRest(); onScroll();
      if (now) { mega.style.transition = 'none'; void mega.offsetWidth; mega.style.transition = ''; }
    }
    const later = (fn, ms) => { clearTimeout(tOpen); tOpen = setTimeout(fn, ms); };
    navLinks.forEach(a => {
      a.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') later(() => open(a.dataset.mega), cur ? 40 : 110); });
      a.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') clearTimeout(tOpen); });
      // touch screens wide enough for the menu: first tap opens the panel, a second tap follows the link
      a.addEventListener('click', e => { if (wide() && cur !== a.dataset.mega && matchMedia('(hover:none)').matches) { e.preventDefault(); open(a.dataset.mega); } });
      a.addEventListener('keydown', e => { if (e.key === 'ArrowDown') { e.preventDefault(); open(a.dataset.mega, true); } });
    });
    mast.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && cur) { clearTimeout(tClose); tClose = setTimeout(() => close(), 260); } });
    mast.addEventListener('pointerenter', () => clearTimeout(tClose));
    scrim && scrim.addEventListener('click', () => close());
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !cur) return;
      const key = cur; close(); const t = $(`.hh-mast [data-mega="${key}"]`); t && t.focus();
    });
    document.addEventListener('focusin', e => { if (cur && !mast.contains(e.target)) close(); });

    // jewelry panel: the large photo follows the category under the pointer
    $$('.hh-mega .hh-mp-cats a[data-feature]').forEach(a => a.addEventListener('pointerenter', () => {
      const figs = a.closest('.hh-mp').querySelectorAll('.hh-mp-feature figure');
      figs.forEach((f, k) => f.classList.toggle('is-on', k === +a.dataset.feature));
    }));

    // shared by the search sheet
    const money = n => new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n);
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // ---------- menu drawer (phones): the menu steps back and each section slides in from the right ----------
    if (dr && mb) {
      const panes = {}; dr.querySelectorAll('[data-pane]').forEach(p => { panes[p.dataset.pane] = p; });
      let pane = 'root';
      function go(key, anim = true) {
        if (key === pane || !panes[key]) return;
        dr.classList.toggle('no-anim', !anim);
        const from = panes[pane], to = panes[key];
        from.classList.remove('is-on'); from.inert = true;
        to.classList.add('is-on'); to.inert = false; to.scrollTop = 0;
        if (key !== 'root') wakePanel(to);
        dr.classList.toggle('is-deep', key !== 'root');
        const back = pane; pane = key;
        if (anim) {
          const f = key === 'root' ? dr.querySelector(`[data-go="${back}"]`) : $('#hh-drBack');
          setTimeout(() => f && f.focus({ preventScroll: true }), 80);
        }
      }
      mb.addEventListener('click', () => {
        go('root', false); dr.classList.remove('no-anim', 'is-closing');
        dr.showModal(); root.classList.add('hh-lock'); mb.setAttribute('aria-expanded', 'true');
      });
      let closing = false;
      function shut() {
        if (!dr.open || closing) return; closing = true;
        dr.classList.add('is-closing');
        const done = () => { dr.classList.remove('is-closing'); dr.close(); closing = false; };
        REDUCE ? done() : setTimeout(done, 300);
      }
      // when the drawer closes because search opened, the search sheet keeps the scroll lock and the focus
      dr.addEventListener('close', () => { mb.setAttribute('aria-expanded', 'false'); if (sq && sq.open) return; root.classList.remove('hh-lock'); mb.focus({ preventScroll: true }); });
      dr.addEventListener('cancel', e => { e.preventDefault(); pane !== 'root' ? go('root') : shut(); });
      $('#hh-menuClose').addEventListener('click', shut);
      $('#hh-drBack').addEventListener('click', () => go('root'));
      dr.addEventListener('click', e => {
        if (e.target === dr) return shut();
        const b = e.target.closest('[data-go]'); if (b) return go(b.dataset.go);
        if (e.target.closest('a[href]')) shut();
      });
      addEventListener('resize', () => { if (dr.open && wide()) { dr.close(); } });
    }
    // ---------- search sheet: opens over the page from every search control (and the "/" key) ----------
    if (sq) {
      const q = $('#hh-sq-q'), res = $('.hh-sq-res'), best = $('.hh-sq-best'), sugg = $('.hh-sq-sugg'), clr = $('.hh-sq-clear');
      const KEY = 'hh-recent';
      let opener = null, shutting = false, seq = 0, t;
      const recent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
      const remember = term => {
        term = term.trim(); if (term.length < 2) return;
        try { localStorage.setItem(KEY, JSON.stringify([term, ...recent().filter(x => x.toLowerCase() !== term.toLowerCase())].slice(0, 5))); } catch (e) {}
      };
      const link = term => `${base}search?q=${encodeURIComponent(term)}&type=product`;
      function drawRecent() {
        const r = recent(), box = $('.hh-sq-recent');
        box.hidden = !r.length;
        box.querySelector('ul').innerHTML = r.map(x => `<li><a href="${link(x)}">${esc(x)}</a></li>`).join('');
      }
      function idle() {
        seq++; clearTimeout(t);
        sq.classList.remove('is-live', 'has-sugg'); res.innerHTML = ''; sugg.innerHTML = ''; best.hidden = false;
      }
      function openSearch(from) {
        opener = from || document.activeElement;
        close(true);
        if (dr && dr.open) dr.close();
        if (sq.open) return q.focus();
        drawRecent(); sq.classList.remove('is-closing');
        sq.showModal(); root.classList.add('hh-lock');
        q.focus(); q.select();
        best.querySelectorAll('.hh-mp-prods[data-load]').forEach(b => loadBoxes(b.dataset.load));
      }
      function shutSearch() {
        if (!sq.open || shutting) return; shutting = true;
        sq.classList.add('is-closing');
        const done = () => { sq.classList.remove('is-closing'); sq.close(); shutting = false; };
        REDUCE ? done() : setTimeout(done, 280);
      }
      sq.addEventListener('close', () => {
        root.classList.remove('hh-lock');
        const o = opener && opener.isConnected && !opener.closest('dialog:not([open])') ? opener : mb;
        o && o.focus({ preventScroll: true });
      });
      sq.addEventListener('cancel', e => { e.preventDefault(); shutSearch(); });
      sq.addEventListener('click', e => {
        if (e.target === sq) return shutSearch();
        if (e.target.closest('.hh-sq-close')) return shutSearch();
        if (e.target.closest('.hh-sq-res a, .hh-sq-sugg a')) remember(q.value);
      });
      $$('[data-search-open]').forEach(b => b.addEventListener('click', e => {
        e.preventDefault(); openSearch(b.closest('#hh-drawer') ? mb : b);
      }));
      document.addEventListener('keydown', e => {
        const a = document.activeElement;
        if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || sq.open) return;
        if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return;
        e.preventDefault(); openSearch(a);
      });
      $('.hh-sq-form').addEventListener('submit', () => remember(q.value));
      clr.addEventListener('click', () => { q.value = ''; clr.hidden = true; idle(); q.focus(); });
      // Esc closes the sheet at once (a search field would otherwise spend the first Esc clearing itself)
      q.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); shutSearch(); } });

      const mark = (s, term) => {
        const e = esc(s), k = esc(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return k ? e.replace(new RegExp(`(${k})`, 'ig'), '<mark>$1</mark>') : e;
      };
      // short names, as on the product cards: "14K Gold Rolo Chain Necklace, Diamond-Cut Round Links" -> "Rolo Chain Necklace"
      const short = t => String(t).replace(/^14k gold /i, '').split(', ')[0];
      const card = p => `<a class="hh-mp-prod" href="${esc(p.url)}"><span class="hh-mp-prod-media">${p.image ? `<img src="${esc(p.image)}${p.image.includes('?') ? '&' : '?'}width=360" alt="" width="360" height="360">` : ''}</span><span class="hh-mp-prod-name">${esc(short(p.title))}</span><span class="hh-mp-prod-price">${p.price_max && p.price_max !== p.price ? T('from', 'From') + ' ' : ''}${money(parseFloat(p.price))}</span></a>`;
      function find(term) {
        const n = ++seq;
        fetch(`${base}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,query,collection&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last`)
          .then(r => r.json()).then(j => {
            if (n !== seq) return;
            const R = (j.resources && j.resources.results) || {}, ps = R.products || [];
            const qs = (R.queries || []).filter(x => x.text.toLowerCase() !== term.toLowerCase()), cs = R.collections || [];
            sugg.innerHTML = (qs.length ? `<p class="hh-mp-k">${T('search_suggestions', 'Suggestions')}</p><ul>${qs.map(x => `<li><a href="${link(x.text)}">${mark(x.text, term)}</a></li>`).join('')}</ul>` : '')
              + (cs.length ? `<p class="hh-mp-k">${T('collections', 'Collections')}</p><ul>${cs.map(c => `<li><a href="${esc(c.url)}">${mark(c.title, term)}</a></li>`).join('')}</ul>` : '');
            res.innerHTML = ps.length
              ? `<div class="hh-sq-head"><p class="hh-mp-k">${T('search_pieces', 'Pieces')}</p><a class="hh-link" href="${link(term)}">${T('search_all', 'See all results')}</a></div><div class="hh-mp-prods is-in">${ps.map(card).join('')}</div>`
              : `<p class="hh-sq-none">${T('search_none', 'Nothing matches “[q]” yet. Try a shorter word, like “chain” or “hoop”, or start with our bestsellers.').replace('[q]', () => esc(term))}</p>`;
            best.hidden = !!ps.length;
            sq.classList.add('is-live'); sq.classList.toggle('has-sugg', !!(qs.length || cs.length));
          }).catch(() => {});
      }
      q.addEventListener('input', () => {
        const term = q.value.trim(); clr.hidden = !q.value;
        clearTimeout(t);
        if (term.length < 2) return idle();
        t = setTimeout(() => find(term), 160);
      });
    }
  }

  // announcement: one promise at a time at every width (heon.css), the next every 6 s. It holds still while the pointer
  // or focus is on the bar (the country picker too), for 10 s after a touch, and while the tab is hidden; under reduced
  // motion only the first shows.
  const bar = $('.hh-announce'), ann = $$('.hh-announce > ul > li');
  if (bar && ann.length > 1 && !REDUCE) {
    let ai = 0, over = false, until = 0;
    bar.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') over = true; });
    bar.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') over = false; });
    bar.addEventListener('focusin', () => { over = true; });
    bar.addEventListener('focusout', () => { over = false; });
    bar.addEventListener('touchstart', () => { until = Date.now() + 10000; }, { passive: true });
    setInterval(() => {
      if (over || document.hidden || Date.now() < until) return;
      // the old promise slides out above (.hh-out), then drops back below the bar out of sight, ready for its next turn
      const out = ann[ai]; out.classList.replace('hh-on', 'hh-out'); setTimeout(() => out.classList.remove('hh-out'), 700);
      ai = (ai + 1) % ann.length; ann[ai].classList.add('hh-on');
    }, 6000);
  }
})();

// country picker (snippets/heon-locale.liquid, 2026-09-28): the panel opens under the announcement bar, the list filters
// as you type, and a country is a submit of the localization form. A country we don't ship to stays on the US store.
// Nobody is moved without asking: visitors from our other countries get the geo popup below.
(() => {
  const loc = document.getElementById('hh-loc');
  if (!loc) return;
  const btn = loc.querySelector('.hh-loc-btn'), panel = loc.querySelector('.hh-loc-panel'), form = loc.querySelector('form'),
    q = loc.querySelector('.hh-loc-q'), list = loc.querySelector('.hh-loc-list'), none = loc.querySelector('.hh-loc-none'),
    items = [...loc.querySelectorAll('.hh-loc-list button')];
  if (!btn || !panel || !form || !q) return;
  const keep = (s, k, v) => { try { return v === undefined ? s.getItem(k) : s.setItem(k, v); } catch (e) { return null; } };

  // return_to is the page's own address: a ?country= or ?currency= in it would undo the choice
  const back = form.querySelector('[name="return_to"]');
  if (back) {
    try {
      const u = new URL(back.value || location.href, location.origin);
      u.searchParams.delete('country'); u.searchParams.delete('currency');
      back.value = u.pathname + u.search + u.hash;
    } catch (e) {}
  }

  const filter = () => {
    const t = q.value.trim().toLowerCase();
    let n = 0;
    items.forEach(b => { const hit = !t || b.dataset.q.includes(t); b.parentNode.hidden = !hit; if (hit) n++; });
    none.hidden = n > 0;
  };
  let y0 = 0;
  // speed (tema team, 2026-09-29): the flags come in the first time the panel opens (each button's data-f)
  let flagged = false;
  const flags = () => {
    if (flagged) return; flagged = true;
    items.forEach(b => {
      if (!b.dataset.f || b.querySelector('img')) return;
      const i = document.createElement('img'); i.alt = ''; i.width = 18; i.height = 12; i.src = b.dataset.f; b.prepend(i);
    });
  };
  const open = on => {
    if (on) flags();
    panel.hidden = !on;
    btn.setAttribute('aria-expanded', String(on));
    loc.classList.toggle('is-open', on);
    if (!on) return;
    y0 = scrollY; q.value = ''; filter();
    const cur = items.find(b => b.hasAttribute('aria-current'));
    if (cur) list.scrollTop = cur.parentNode.offsetTop - list.clientHeight / 2 + cur.offsetHeight / 2;
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) q.focus({ preventScroll: true });
  };
  btn.addEventListener('click', () => open(panel.hidden));
  q.addEventListener('input', filter);
  q.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const shown = items.filter(b => !b.parentNode.hidden);
    if (shown.length === 1) shown[0].click();
  });
  document.addEventListener('click', e => { if (!panel.hidden && !loc.contains(e.target)) open(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { open(false); btn.focus(); } });
  addEventListener('scroll', () => { if (!panel.hidden && Math.abs(scrollY - y0) > 80) open(false); }, { passive: true });
  // a country brings its language when it is published, else English (2026-09-28, CEO); the language row above the
  // countries changes the language alone. Hidden country/language fields left by an earlier submit (the geo popup, or a
  // page restored from the back-forward cache) are cleared first, so they can't override this choice.
  const LANG = { DE: 'de', AT: 'de', CH: 'de', LU: 'de', FR: 'fr', BE: 'fr', ES: 'es', MX: 'es', IT: 'it' };
  const langs = [...loc.querySelectorAll('.hh-loc-langs button')].map(b => b.value);
  let picked = null;
  form.addEventListener('click', e => { const b = e.target.closest('button[type="submit"]'); if (b) picked = b; });
  form.addEventListener('submit', e => {
    keep(localStorage, 'hh-loc', '1');
    const s = e.submitter || picked;
    form.querySelectorAll('input[type="hidden"][name="country_code"], input[type="hidden"][name="language_code"]').forEach(i => i.remove());
    if (!s || s.name !== 'country_code' || !langs.length) return;
    const want = [LANG[s.value], 'en'].find(l => l && langs.includes(l));
    if (!want) return;
    const i = document.createElement('input');
    i.type = 'hidden'; i.name = 'language_code'; i.value = want;
    form.appendChild(i);
  });
})();

// geo popup (2026-09-28, CEO): a visitor whose IP is in one of our other countries is asked, once, whether to see the site
// in that country's currency, and in its language too as soon as that language is published (heon-locale.liquid lists
// the countries, currencies and published languages in #hh-geo-cfg, so a new language needs no code change). It replaced
// the silent switch the picker used to make. The answer (a close counts as "no") is kept 180 days. Nothing shows for the
// US, for countries we don't ship to (they stay on the US store), when nothing would change (Norway, Mexico stay in USD),
// to bots, after a manual country choice, on pages that name a ?country=, in the theme editor, cart and account pages.
// Worded in the visitor's language where we have it, else English. Never together with the Klaviyo sign-up: it waits
// for the page-load logo, stands down for this page if Klaviyo is already open, and keeps Klaviyo hidden while it is
// open (html.hh-geo-on, heon.css). "Yes" submits the picker's localization form.
// Testing: ?hhgeo=DE acts as if the visitor were in Germany; ?hhgeo=reset forgets the answer and any manual choice.
(() => {
  const cfgEl = document.getElementById('hh-geo-cfg'), loc = document.getElementById('hh-loc'), form = document.getElementById('hh-loc-form'),
    root = document.documentElement;
  if (!cfgEl || !loc || !form || typeof HTMLDialogElement !== 'function') return;
  // storage can be missing or throw (private modes, blocked cookies): every access is guarded, and the answer goes to both
  const keep = (s, k, v) => { try { const st = window[s]; return v === undefined ? st.getItem(k) : v === null ? st.removeItem(k) : st.setItem(k, v); } catch (e) { return null; } };
  const both = (k, v) => { keep('localStorage', k, v); keep('sessionStorage', k, v); };
  const KEY = 'hh-geo-a', DAYS = 180, REDUCE = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const sim = (/[?&]hhgeo=([a-z]{2}|reset)(?=&|#|$)/i.exec(location.search) || [])[1];
  if (sim && sim.toLowerCase() === 'reset') { both(KEY, null); both('hh-loc', null); keep('sessionStorage', 'hh-geo-c', null); }
  const answered = ['localStorage', 'sessionStorage'].some(s => { const t = +String(keep(s, KEY) || '').split('.')[1]; return t > 0 && Date.now() - t < DAYS * 864e5; });
  const bot = navigator.webdriver || /bot|crawl|spider|slurp|facebookexternalhit|embedly|pinterest|lighthouse|headless|google-|mediapartners|bingpreview|yandex|baidu|petalsearch|semrush|ahrefs/i.test(navigator.userAgent);
  if (bot || answered || keep('localStorage', 'hh-loc') || /[?&](country|currency)=/.test(location.search)) return;
  let cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const cc = {}; cfg.cc.forEach(([k, n, c, s]) => { cc[k] = { n, c, s }; });
  const base = x => String(x || '').toLowerCase().split('-')[0];
  const endonym = k => (cfg.langs.find(l => l[0] === k) || [k, k])[1];

  // the language each country is asked in, and offered once it is published; the others get English and currency only
  const LANG = { DE: 'de', AT: 'de', CH: 'de', FR: 'fr', ES: 'es', MX: 'es', IT: 'it', NL: 'nl', PT: 'pt', SE: 'sv', DK: 'da', FI: 'fi', PL: 'pl', CZ: 'cs', HR: 'hr', IS: 'is', JP: 'ja', KR: 'ko' };
  // t: the first line (per country, so each language keeps its own grammar), q: currency only, ql: language and currency,
  // y/yl: yes, n: no ({x} = what stays), o: the link to the picker, x: close. {m} = "EUR (€)", {k} = "EUR".
  const T = {
    en: { t: 'Looks like you’re in {c}.', q: 'See prices in {m}?', ql: 'Shop in {l} with prices in {m}?', y: 'Yes, show {k}', yl: 'Yes, switch', n: 'No, keep {x}', o: 'Choose another country', x: 'Close' },
    de: { t: { DE: 'Sie befinden sich anscheinend in Deutschland.', AT: 'Sie befinden sich anscheinend in Österreich.', CH: 'Sie befinden sich anscheinend in der Schweiz.' }, q: 'Preise in {m} anzeigen?', ql: 'Auf Deutsch einkaufen, mit Preisen in {m}?', y: 'Ja, {k} anzeigen', yl: 'Ja, wechseln', n: 'Nein, {x} behalten', o: 'Anderes Land wählen', x: 'Schließen' },
    fr: { t: { FR: 'Il semble que vous soyez en France.' }, q: 'Afficher les prix en {m} ?', ql: 'Acheter en français, avec les prix en {m} ?', y: 'Oui, afficher en {k}', yl: 'Oui, changer', n: 'Non, garder {x}', o: 'Choisir un autre pays', x: 'Fermer' },
    es: { t: { ES: 'Parece que estás en España.', MX: 'Parece que estás en México.' }, q: '¿Ver los precios en {m}?', ql: '¿Comprar en español, con precios en {m}?', y: 'Sí, ver en {k}', yl: 'Sí, cambiar', n: 'No, mantener {x}', o: 'Elegir otro país', x: 'Cerrar' },
    it: { t: { IT: 'Sembra che tu sia in Italia.' }, q: 'Vedere i prezzi in {m}?', ql: 'Acquistare in italiano, con prezzi in {m}?', y: 'Sì, mostra in {k}', yl: 'Sì, cambia', n: 'No, resta in {x}', o: 'Scegli un altro paese', x: 'Chiudi' },
    nl: { t: { NL: 'Het lijkt erop dat je in Nederland bent.' }, q: 'Prijzen in {m} bekijken?', ql: 'Winkelen in het Nederlands, met prijzen in {m}?', y: 'Ja, prijzen in {k}', yl: 'Ja, wisselen', n: 'Nee, blijf bij {x}', o: 'Kies een ander land', x: 'Sluiten' },
    pt: { t: { PT: 'Parece que está em Portugal.' }, q: 'Ver os preços em {m}?', ql: 'Comprar em português, com preços em {m}?', y: 'Sim, ver em {k}', yl: 'Sim, mudar', n: 'Não, manter {x}', o: 'Escolher outro país', x: 'Fechar' },
    sv: { t: { SE: 'Det ser ut som att du är i Sverige.' }, q: 'Visa priser i {m}?', ql: 'Handla på svenska, med priser i {m}?', y: 'Ja, visa i {k}', yl: 'Ja, byt', n: 'Nej, behåll {x}', o: 'Välj ett annat land', x: 'Stäng' },
    da: { t: { DK: 'Det ser ud til, at du er i Danmark.' }, q: 'Se priser i {m}?', ql: 'Handl på dansk, med priser i {m}?', y: 'Ja, vis i {k}', yl: 'Ja, skift', n: 'Nej, behold {x}', o: 'Vælg et andet land', x: 'Luk' },
    fi: { t: { FI: 'Näyttää siltä, että olet Suomessa.' }, q: 'Näytetäänkö hinnat valuutassa {m}?', ql: 'Asioidaanko suomeksi, hinnat valuutassa {m}?', y: 'Kyllä, näytä {k}', yl: 'Kyllä, vaihda', n: 'Ei, pidä {x}', o: 'Valitse toinen maa', x: 'Sulje' },
    pl: { t: { PL: 'Wygląda na to, że jesteś w Polsce.' }, q: 'Pokazać ceny w {m}?', ql: 'Zakupy po polsku, z cenami w {m}?', y: 'Tak, pokaż w {k}', yl: 'Tak, zmień', n: 'Nie, zostaw {x}', o: 'Wybierz inny kraj', x: 'Zamknij' },
    cs: { t: { CZ: 'Vypadá to, že jste v Česku.' }, q: 'Zobrazit ceny v {m}?', ql: 'Nakupovat v češtině, s cenami v {m}?', y: 'Ano, zobrazit v {k}', yl: 'Ano, přepnout', n: 'Ne, ponechat {x}', o: 'Vybrat jinou zemi', x: 'Zavřít' },
    hr: { t: { HR: 'Čini se da ste u Hrvatskoj.' }, q: 'Prikazati cijene u {m}?', ql: 'Kupovati na hrvatskom, s cijenama u {m}?', y: 'Da, prikaži u {k}', yl: 'Da, promijeni', n: 'Ne, zadrži {x}', o: 'Odaberite drugu zemlju', x: 'Zatvori' },
    is: { t: { IS: 'Það lítur út fyrir að þú sért á Íslandi.' }, q: 'Sýna verð í {m}?', ql: 'Versla á íslensku, með verð í {m}?', y: 'Já, sýna í {k}', yl: 'Já, skipta', n: 'Nei, halda {x}', o: 'Veldu annað land', x: 'Loka' },
    ja: { t: { JP: '日本からアクセスされているようです。' }, q: '価格を{m}で表示しますか？', ql: '日本語、{m}の価格でご覧になりますか？', y: 'はい、{k}で表示', yl: 'はい、切り替える', n: 'いいえ、{x}のまま', o: '別の国を選ぶ', x: '閉じる' },
    ko: { t: { KR: '한국에서 접속하신 것 같습니다.' }, q: '가격을 {m} 기준으로 보시겠어요?', ql: '한국어로, {m} 가격으로 쇼핑하시겠어요?', y: '네, {k} 표시', yl: '네, 변경', n: '아니요, {x} 유지', o: '다른 국가 선택', x: '닫기' }
  };

  // wait for the page-load logo to finish, then for 1.5 s with no menu, search, drawer or picker open and the tab in view;
  // if the Klaviyo sign-up is up first, ask on a later page instead. Gives up after a minute.
  const klaviyo = () => [...document.querySelectorAll('[role="dialog"][class*="kl-private-reset-css"]')].some(d => { const r = d.getBoundingClientRect(); return r.width > 240 && r.height > 240; });
  const busy = () => /\bhh-in-(full|short)\b/.test(root.className) || root.classList.contains('hh-lock') || document.hidden
    || !!document.querySelector('dialog[open], .drawer[open], .js-overlay.is-visible, #hh-loc.is-open');
  function when(fn) {
    let n = 0, calm = 0;
    (function tick() {
      if (klaviyo()) return;
      if (busy()) calm = 0; else if ((calm += 250) >= 1500) return fn();
      if (++n < 240) setTimeout(tick, 250);
    })();
  }

  function ask(c, to, want, pub) {
    const t = T[want] || T.en, en = t === T.en;
    let name = to.n;
    try { name = new Intl.DisplayNames(['en'], { type: 'region' }).of(c) || name; } catch (e) {}
    const title = en ? T.en.t.replace('{c}', (/^(United |Netherlands|Czech Republic|Philippines|Bahamas)/.test(name) ? 'the ' : '') + name) : t.t[c];
    const m = to.c + (to.s && to.s !== to.c ? ` (${to.s})` : '');
    const q = (pub ? t.ql : t.q).replace('{m}', m).replace('{l}', endonym(pub));
    const yes = pub ? t.yl : t.y.replace('{k}', to.c);
    const no = t.n.replace('{x}', pub ? `${endonym(cfg.lang)} · ${cfg.cur}` : cfg.cur);
    const esc = s => String(s).replace(/[&<>"]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    const fb = loc.querySelector(`.hh-loc-list button[value="${c}"]`), fi = fb && fb.querySelector('img');
    const flag = fb && (fb.dataset.f || (fi && fi.getAttribute('src')));
    const d = document.createElement('dialog');
    d.className = 'hh hh-geo'; d.lang = en ? 'en' : want;
    d.setAttribute('aria-labelledby', 'hh-geo-t'); d.setAttribute('aria-describedby', 'hh-geo-q');
    d.innerHTML = (flag ? `<img class="hh-geo-flag" src="${esc(flag)}" alt="" width="27" height="18">` : '')
      + `<h2 class="hh-geo-t" id="hh-geo-t">${esc(title)}</h2><p class="hh-geo-q" id="hh-geo-q">${esc(q)}</p>`
      + `<div class="hh-geo-b"><button type="button" class="hh-btn hh-geo-y" autofocus>${esc(yes)}</button>`
      + `<button type="button" class="hh-btn hh-btn--ghost hh-geo-n">${esc(no)}</button></div>`
      + `<button type="button" class="hh-geo-o">${esc(t.o)}</button>`
      + `<button type="button" class="hh-geo-x" aria-label="${esc(t.x)}"><svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13"/></svg></button>`;
    const back = document.activeElement;
    let done = false;
    // y: switch (the page reloads in the new country, so the dialog and the Klaviyo hold simply stay until it does);
    // n: keep things as they are; o: open the country picker instead
    const answer = a => {
      if (done) return; done = true;
      both(KEY, a + '.' + Date.now());
      if (a === 'y') return go();
      d.classList.add('is-closing');
      setTimeout(() => {
        d.close(); d.remove();
        setTimeout(() => root.classList.remove('hh-geo-on'), 700);
        if (a === 'o') {
          // the picker sits in the announcement bar, which slides away once the page is scrolled
          if (scrollY) scrollTo({ top: 0, behavior: 'instant' });
          setTimeout(() => { const b = loc.querySelector('.hh-loc-btn'); if (b) b.click(); }, 120);
        } else if (back && back.isConnected && back !== document.body) back.focus({ preventScroll: true });
      }, REDUCE ? 0 : 280);
    };
    const go = () => {
      const put = (k, v) => {
        let i = form.querySelector(`input[type="hidden"][name="${k}"]`);
        if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = k; form.appendChild(i); }
        i.value = v;
      };
      put('country_code', c);
      if (pub) put('language_code', pub);
      try { const u = new URL(location.href); ['country', 'currency', 'hhgeo'].forEach(k => u.searchParams.delete(k)); put('return_to', u.pathname + u.search + u.hash); } catch (e) {}
      keep('localStorage', 'hh-loc', '1');
      d.querySelector('.hh-geo-y').classList.add('is-busy');
      form.submit();
    };
    d.querySelector('.hh-geo-y').addEventListener('click', () => answer('y'));
    d.querySelector('.hh-geo-n').addEventListener('click', () => answer('n'));
    d.querySelector('.hh-geo-x').addEventListener('click', () => answer('n'));
    d.querySelector('.hh-geo-o').addEventListener('click', () => answer('o'));
    d.addEventListener('cancel', e => { e.preventDefault(); answer('n'); });
    // a click on the backdrop lands on the dialog itself, outside its box
    d.addEventListener('click', e => {
      if (e.target !== d) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) answer('n');
    });
    // Klaviyo closes its sign-up on any click or Esc outside it; if it opened, hidden, behind this dialog, our clicks
    // must not reach it, or it would count as closed
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchend', 'keydown', 'keyup'].forEach(t => d.addEventListener(t, e => e.stopPropagation()));
    document.body.appendChild(d);
    root.classList.add('hh-geo-on');
    d.showModal();
  }

  // Shopify's own guess from the IP, fetched once a session
  const got = keep('sessionStorage', 'hh-geo-c');
  const detect = sim && sim.length === 2 ? Promise.resolve(sim.toUpperCase()) : got ? Promise.resolve(got)
    : fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { const c = (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || '-'; keep('sessionStorage', 'hh-geo-c', c); return c; });
  detect.then(c => {
    const to = cc[c];
    if (!to || c === 'US' || c === cfg.here) return;
    const want = LANG[c];
    const pub = want && want !== base(cfg.lang) ? (cfg.langs.find(l => base(l[0]) === want) || [])[0] : null;
    if (!pub && to.c === cfg.cur) return;
    when(() => ask(c, to, want, pub));
  }).catch(() => {});
})();

// footer tabs on phones (CEO 2026-10-03): Shop, Help and Heon become three tabs (snippets/heon-footer, heon.css
// "Footer tabs"). One gold line glides to the chosen tab, the new links slide in from that side while the old ones fade,
// and the box eases to the new height. A sideways swipe over the links switches too. Arrow keys, Home and End move
// between tabs (ARIA tabs pattern). Wider screens keep the columns, so the tab roles are set only while phones see tabs.
(() => {
  const bar = document.querySelector('.hh-ftabs'), box = document.querySelector('.hh-fpanes');
  if (!bar || !box) return;
  const tabs = [...bar.querySelectorAll('[role="tab"]')], ink = bar.querySelector('.hh-ftabs-ink');
  const panes = tabs.map(b => document.getElementById(b.getAttribute('aria-controls')));
  const phone = matchMedia('(max-width:760px)'), REDUCE = matchMedia('(prefers-reduced-motion:reduce)').matches;
  let cur = Math.max(0, tabs.findIndex(b => b.getAttribute('aria-selected') === 'true')), endT, sx = null, sy = 0, swiped = 0;
  function inkTo(anim) {
    if (!ink || !phone.matches) return;
    const s = tabs[cur].firstElementChild.getBoundingClientRect(), r = bar.getBoundingClientRect();
    if (!anim) ink.style.transition = 'none';
    ink.style.width = s.width + 'px'; ink.style.transform = `translateX(${s.left - r.left}px)`;
    if (!anim) { void ink.offsetWidth; ink.style.transition = ''; }
  }
  function mark() {
    tabs.forEach((b, i) => {
      const on = i === cur;
      b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1;
      panes[i].classList.toggle('is-on', on); panes[i].style.setProperty('--x', Math.sign(i - cur));
    });
  }
  function show(k, focus) {
    if (focus) tabs[k].focus();
    if (k === cur) return;
    const h0 = box.offsetHeight;
    box.style.height = ''; cur = k; mark(); inkTo(true);
    if (REDUCE || !phone.matches) return;
    const h1 = box.offsetHeight;
    box.style.height = h0 + 'px'; box.classList.add('is-moving'); void box.offsetHeight; box.style.height = h1 + 'px';
    clearTimeout(endT); endT = setTimeout(() => { box.style.height = ''; box.classList.remove('is-moving'); }, 520);
  }
  function roles() {
    panes.forEach((p, i) => {
      if (phone.matches) { p.setAttribute('role', 'tabpanel'); p.setAttribute('aria-labelledby', tabs[i].id); }
      else { p.removeAttribute('role'); p.removeAttribute('aria-labelledby'); }
    });
    inkTo(false);
  }
  tabs.forEach((b, i) => {
    b.addEventListener('click', () => show(i));
    b.addEventListener('keydown', e => {
      const j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (j === undefined) return;
      e.preventDefault(); show((j + tabs.length) % tabs.length, true);
    });
  });
  // a sideways swipe over the links: left for the next tab, right for the previous one; the tap that ends it opens nothing
  box.addEventListener('touchstart', e => { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive: true });
  box.addEventListener('touchend', e => {
    if (sx === null || !phone.matches) return;
    const t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
    if (Math.abs(dx) < 48 || Math.abs(dx) < 2 * Math.abs(dy)) return;
    const k = cur - Math.sign(dx);
    if (k < 0 || k >= tabs.length) return;
    swiped = Date.now(); show(k);
  }, { passive: true });
  box.addEventListener('click', e => { if (Date.now() - swiped < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
  phone.addEventListener('change', roles);
  addEventListener('resize', () => inkTo(false));
  if (document.fonts) document.fonts.ready.then(() => inkTo(false));
  mark(); roles();
})();

// heon-m's market banner (snippets/heonm-ab, 2026-10-28) is put at the top of <main>, which on the homepage lies under the
// fixed transparent masthead: hidden on desktop, spilling over the logo on phones. Move it below the hero instead.
// heon-m rebuilds its own files on every change, so the fix lives here.
(() => {
  const main = document.querySelector('main'), hero = document.querySelector('#hh .hh-top');
  if (!main || !hero) return;
  const move = () => { const top = main.querySelector(':scope > [data-heonm-top]'); if (top) hero.after(top); };
  move(); new MutationObserver(move).observe(main, { childList: true });
})();
